
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-we-work",
      function () {
        return require("private-next-pages/how-we-work.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-we-work"])
      });
    }
  